import { authHeader, getApiBase } from "_helpers";
import { cookieService } from "_services";

const getAuditLogs = async (section, startDate, endDate) => {
  const apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let url = `${apiBase}/admin/audit-logs/date-range?section=${encodeURIComponent(
    section
  )}&startDate=${startDate}&endDate=${endDate}`;
  if (jwtCookie) {
    url += `&${jwtCookie}`;
  }

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 403) {
    throw new Error("Invalid Auth Token");
  }
  if (!response.ok) {
    throw new Error("Failed to fetch audit logs");
  }

  return await response.json();
};

const searchByUsername = async (username, limit = 100) => {
  const apiBase = getApiBase();
  let jwtCookie = "";
  if (process.env.NODE_ENV !== "production") {
    jwtCookie = `jwtCookie=${encodeURI(cookieService.get("token"))}`;
  }

  let url = `${apiBase}/admin/audit-logs/search/username?username=${encodeURIComponent(username)}&limit=${limit}`;
  if (jwtCookie) {
    url += `&${jwtCookie}`;
  }

  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  const response = await fetch(url, requestOptions);

  if (response.status === 403) {
    throw new Error("Invalid Auth Token");
  }
  if (!response.ok) {
    throw new Error("Failed to search by username");
  }

  return await response.json();
};

export const adminAuditLogService = {
  getAuditLogs,
  searchByUsername,
};
